/**
 * A CSS media query as React state.
 *
 * Layout belongs in CSS, and almost everything responsive here is a Tailwind
 * breakpoint. This exists for the cases where the *data* changes with the
 * viewport rather than its presentation — the alarm table drops columns on a
 * phone instead of squeezing eight of them into 390 px.
 */
import { useSyncExternalStore } from 'react';

function subscribe(query: string): (onChange: () => void) => () => void {
  return (onChange) => {
    if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
    const list = window.matchMedia(query);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  };
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    subscribe(query),
    () =>
      typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false,
    () => false,
  );
}

/** Tailwind's `sm` breakpoint: below it, the console is on a phone. */
export const PHONE_QUERY = '(max-width: 639px)';
